import { useQuery } from '@tanstack/react-query';
import { fetchSectors } from '../api/taxonomy.api';
import { TAXONOMY_KEYS } from './taxonomy.keys';

/** Near-static (~18 sectors / ~90 subsectors) - long staleTime, prefetched. */
const STALE_TIME_MS = 24 * 60 * 60 * 1000;

export function useSectors() {
  return useQuery({
    queryKey: TAXONOMY_KEYS.sectors,
    queryFn: fetchSectors,
    staleTime: STALE_TIME_MS,
  });
}
